__turbopack_context__.v({
  "StreamField__Component": "B_J_Dq_StreamField__Component",
  "StreamField__Component--Accordion": "B_J_Dq_StreamField__Component--Accordion",
  "StreamField__Component--ArtistNameList": "B_J_Dq_StreamField__Component--ArtistNameList",
  "StreamField__Component--AudioPlayerList": "B_J_Dq_StreamField__Component--AudioPlayerList",
  "StreamField__Component--Banner": "B_J_Dq_StreamField__Component--Banner",
  "StreamField__Component--EmbedIframe": "B_J_Dq_StreamField__Component--EmbedIframe",
  "StreamField__Component--ImageVideoCarousel": "B_J_Dq_StreamField__Component--ImageVideoCarousel",
  "StreamField__Component--Manual": "B_J_Dq_StreamField__Component--Manual",
  "StreamField__Component--PlayableAudioCardList": "B_J_Dq_StreamField__Component--PlayableAudioCardList",
  "StreamField__Component--ProductCardList": "B_J_Dq_StreamField__Component--ProductCardList",
  "StreamField__Component--ProductHighlightItem": "B_J_Dq_StreamField__Component--ProductHighlightItem",
  "StreamField__Component--ProductLogoImage": "B_J_Dq_StreamField__Component--ProductLogoImage",
  "StreamField__Component--ProductsList": "B_J_Dq_StreamField__Component--ProductsList",
  "StreamField__Component--ReleaseImageCardList": "B_J_Dq_StreamField__Component--ReleaseImageCardList",
  "StreamField__Component--RichText": "B_J_Dq_StreamField__Component--RichText",
  "StreamField__Component--SoftwareCardList": "B_J_Dq_StreamField__Component--SoftwareCardList",
  "StreamField__Component--ThreeColumnModule": "B_J_Dq_StreamField__Component--ThreeColumnModule",
});
